import React from "react";
//Material imports
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography"; //Limitless imports

import { withi18n } from "../../hocs/i18n";

var FooterTitle = function FooterTitle(_ref) {
  var classes = _ref.classes,
      title = _ref.title,
      t = _ref.t,
      position = _ref.position;

  if (position === "bottom") {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.bottomContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.bottomRoot
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      align: "center",
      classes: {
        caption: classes.caption
      }
    }, title)));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement(Typography, {
    classes: {
      root: classes.root
    },
    component: "span"
  }, t(title)));
};

var styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.primary.contrastText,
      display: "flex",
      flex: 1,
      alignItems: "center",
      justifyContent: "center"
    },
    title: {
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
      backgroundColor: theme.palette.primary.main,
      padding: 4,
      height: 44
    },
    bottomContainer: {
      padding: 2
    },
    bottomRoot: {
      boxShadow: "0 -2px 0 rgba(0, 0, 0, 0.04), 0 -1px 0 rgba(0, 0, 0, 0.06)",
      width: "100%"
    },
    caption: {
      color: "#666",
      height: 54,
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      width: "94%",
      margin: "auto"
    }
  };
};

export default withStyles(styles)(withi18n(FooterTitle));
FooterTitle.defaultProps = {
  position: "top"
};